import { Action } from 'redux';
import { AppStates } from '../reducers/app';
import { Publication } from '../types/epub';

// Top level actions which effect entire states.
// NOTE : Keep top level actions less.

export const APP_REPLACE_STATES = 'APP_REPLACE_STATES';
export const APP_SET_PUBLICATION = 'APP_SET_PUBLICATION';
export const APP_START_SAVING_PROCESS = 'APP_START_SAVING_PROCESS';
export const APP_FINISH_SAVING_PROCESS = 'APP_FINISH_SAVING_PROCESS';
export const APP_SET_COMPOSER_MODE = 'APP_SET_COMPOSER_MODE';
// For UI Develop
export const APP_SET_LEGACY_UI = 'APP_SET_LEGACY_UI';
// For Develop
export const APP_SET_DEVELOP_MODE = 'APP_SET_DEVELOP_MODE';

export interface AppReplaceStatesAction extends Action {
  type: typeof APP_REPLACE_STATES;
  data: AppStates;
}

// "PublicationAction" などに分けても良いが、readonlyで増える予定もないのでここに置いてしまう
export interface AppSetPublicationAction extends Action {
  type: typeof APP_SET_PUBLICATION;
  publication: Publication;
  installedComponents: ReadonlyArray<string>;
}

interface StartSavingProcessAction extends Action {
  type: typeof APP_START_SAVING_PROCESS;
}

interface FinishSavingProcessAction extends Action {
  type: typeof APP_FINISH_SAVING_PROCESS;
}

interface AppSetComposerModeAction extends Action {
  composerMode: boolean;
  type: typeof APP_SET_COMPOSER_MODE;
}

// For UI Develop
export interface AppSetLegacyUIAction extends Action {
  legacyUI: boolean;
  type: typeof APP_SET_LEGACY_UI;
}
// For Develop
export interface AppSetDevelopModeAction extends Action {
  developMode: boolean;
  type: typeof APP_SET_DEVELOP_MODE;
}

export type AppAction = (
  AppReplaceStatesAction
  | AppSetPublicationAction
  | StartSavingProcessAction
  | FinishSavingProcessAction
  | AppSetComposerModeAction
  | AppSetLegacyUIAction
  | AppSetDevelopModeAction
);

export const replaceAppStates = (data: AppStates): AppReplaceStatesAction => ({
  data,
  type: APP_REPLACE_STATES,
});

export const setPublication = (
  publication: Publication,
  installedComponents: ReadonlyArray<string>,
): AppSetPublicationAction => ({
  publication,
  installedComponents,
  type: APP_SET_PUBLICATION,
});

export const startSavingProcess = (): StartSavingProcessAction => ({
  type: APP_START_SAVING_PROCESS,
});

export const finishSavingProcess = (): FinishSavingProcessAction => ({
  type: APP_FINISH_SAVING_PROCESS,
});

export const setComposerMode = (composerMode: boolean): AppSetComposerModeAction => ({
  composerMode,
  type: APP_SET_COMPOSER_MODE,
});

// For UI Develop
export const setLegacyUI = (legacyUI: boolean): AppSetLegacyUIAction => ({
  legacyUI,
  type: APP_SET_LEGACY_UI,
});
// For Develop
export const setDevelopMode = (developMode: boolean): AppSetDevelopModeAction => ({
  developMode,
  type: APP_SET_DEVELOP_MODE,
});

export const isAppAction = (action: Action): action is AppAction => {
  switch (action.type) {
    case APP_REPLACE_STATES:
    case APP_SET_PUBLICATION:
    case APP_START_SAVING_PROCESS:
    case APP_FINISH_SAVING_PROCESS:
    case APP_SET_COMPOSER_MODE:
    case APP_SET_LEGACY_UI:
    case APP_SET_DEVELOP_MODE:
      return true;
    default:
      return false;
  }
};
